module.exports = __webpack_public_path__ + "static/img/jianchuang2.38de30b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jianchuang2.jpg
// module id = hGSO
// module chunks = 3